import type { NumberFormatValues } from 'react-number-format';
import { removeComma } from './formula-string-calculator';

const isNegativeZero = (value: string) => {
  // Check if the value is -0, -0.0, -0.00, -0.000, etc.
  const isFixedMinusZero = /^-0(\.0+)?$/.test(value);
  return isFixedMinusZero || value === '-0.';
};

export const handleInvalidNumber = (
  value: string,
  setValue: (value: number | null) => void,
) => {
  if (value === '-') {
    setValue(null);
  } else if (
    Number.isNaN(Number(removeComma(value))) ||
    isNegativeZero(value)
  ) {
    setValue(0);
  }
};

export function isValidNumberFormatValues({
  value,
  floatValue,
}: Omit<NumberFormatValues, 'formattedValue'>) {
  return (
    value !== '-' &&
    !isNegativeZero(value) &&
    (floatValue === undefined || !Number.isNaN(floatValue))
  );
}

export const isValidNumber = (value: unknown) => {
  return !Number.isNaN(Number(value));
};
